import React from "react";
import { StyledTextField } from "./AuthTextField.styles";
import { SxProps } from "@mui/system";
import {
  Box,
  TextFieldProps as MuiTextFieldProps,
  Typography,
} from "@mui/material";

export interface AuthTextFieldProps extends Omit<MuiTextFieldProps, "type"> {
  label: string;
  type?: "text" | "password";
  sx?: SxProps;
}

const AuthTextField: React.FC<AuthTextFieldProps> = ({
  label,
  type = "text",
  ...props
}) => {
  return (
    <Box>
      <Typography pb={1} textTransform={"capitalize"}>
        {label}
      </Typography>
      <StyledTextField type={type} variant="outlined" fullWidth {...props} />
    </Box>
  );
};

export default AuthTextField;
